import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const CheckboxWrapper = styled.div`
  padding: 8px 0px 8px 8px;
`;

export const CheckboxList = styled.div`
  padding-bottom: 10px;
  border-bottom: 1px solid var(--beam-color-neutral-n300);
`;

export const SourceList = styled.div`
  padding: 8px;
  display: flex;

  justify-content: space-between;
`;

export const GroupSource = styled.div`
  display: flex;
  column-gap: 8px;
`;
